// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__cBsBQ","selects":"Documents_selects__2wrE_"};